import React from 'react';
import ListItem from 'components/ListItem';
import { FertilizerComment } from 'services/fertilizerEvents/types';

export interface OwnProps {
    comment?: FertilizerComment;
}

type Props = OwnProps;

export default function SummaryApplicationComment(
    props: Props
): React.ReactElement | null {
    const { comment } = props;

    if (comment) {
        return <ListItem description="Additional comment" value={comment} />;
    }

    return null;
}
